/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (value) {
      // console.log('Un trabajador de servicio sirve la aplicación desde la caché.')
    },
    registered (value) {
      // console.log('El trabajador de servicio ha sido registrado.')
    },
    cached () {
      // console.log('El contenido se ha almacenado en caché para su uso sin conexión.')
    },
    updatefound () {
      // console.log('Se está descargando nuevo contenido.')
    },
    updated () {
      // console.log('Nuevo contenido está disponible; porfavor refresca.')
    },
    offline () {
      // console.log('No se encontró conexión a internet. La aplicación se ejecuta en modo fuera de línea.')
    },
    error (error) {
      console.error('Error durante el registro del trabajador de servicio:', error)
    }
  })
}
